module.exports = __webpack_public_path__ + "img/Group 4642_copy2.ea986d0d.png";